import type {StartQueryActionCreatorOptions} from '@reduxjs/toolkit/query'

import type {AppThunk} from '../../../../../actions/types'
import {archivedProjectsArg, overviewArg, sidebarArg} from '../../../../../rest/projects'
import type {LoadedEndpoints} from '../../../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../../../routes/loadEndpoint'
import {restApi} from '../../../../../services/rest'

import {projectsSidebarApi} from './ProjectsSidebar.api'
import {getExpandStateEndpoint} from './ProjectsSidebar.selectors'

export const preloadProjectsSidebar =
  (options?: StartQueryActionCreatorOptions): AppThunk<LoadedEndpoints> =>
  (dispatch, getState) => {
    const result: LoadedEndpoints = [
      dispatch(loadEndpoint(projectsSidebarApi.endpoints.getBuildTypesCount, undefined, options)),
    ]
    const overviewProjects = dispatch(
      loadEndpoint(restApi.endpoints.getSidebarProjectsNormalized, overviewArg, options),
    )
    result.push(overviewProjects)
    const projects = dispatch(
      loadEndpoint(restApi.endpoints.getSidebarProjectsNormalized, sidebarArg, options),
    )
    result.push(projects)

    const state = getState()
    const {showArchivedProjects} = state.projectsSidebar
    if (showArchivedProjects) {
      const archivedProjects = dispatch(
        loadEndpoint(restApi.endpoints.getSidebarProjectsNormalized, archivedProjectsArg, options),
      )
      result.push(archivedProjects)
    }

    const expandStateEndpoint = getExpandStateEndpoint(state)
    if (expandStateEndpoint) {
      result.push(
        dispatch(loadEndpoint(restApi.endpoints.getExpandState, expandStateEndpoint, options)),
      )
    }
    return result
  }
